import React from 'react'
import { View } from '@/components'
import { ComponentVariants, PropsOf, useDefaultComponentStyle } from '@codeleap/common'
import { StylesOf } from '@codeleap/web'
import { CenterWrapperStyles, CenterWrapperComposition } from '../app/stylesheets/CenterWrapper'

export type CenterWrapperProps = React.PropsWithChildren<{
  styles?: StylesOf<CenterWrapperComposition>
  innerProps?: Partial<PropsOf<typeof View>>
  style?: React.CSSProperties
} & ComponentVariants<typeof CenterWrapperStyles>>

export const CenterWrapper = (props: CenterWrapperProps) => {
  const {
    children,
    variants = [],
    styles = {},
    responsiveVariants = {},
    innerProps = {},
    style = {},
    ...rest
  } = props

  const variantStyles = useDefaultComponentStyle<'u:CenterWrapper', typeof CenterWrapperStyles>('u:CenterWrapper', {
    variants,
    styles,
    responsiveVariants,
  })

  return (
    <View css={[variantStyles.wrapper, style]} {...rest}>
      <View css={[variantStyles.innerWrapper]} {...innerProps}>
        {children}
      </View>
    </View>
  )
}
